import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { VendorGroup } from '../models/vendor-group.model';
import { ConfigService } from 'src/app/core/config/config-service';

@Injectable({ providedIn: 'root' })
export class VendorGroupService {
  constructor(
    private http: HttpClient,
    private configService: ConfigService
  ) {}

  private get baseUrl(): string {
    return `${this.configService.getUrlVendorCatalogApi()}/vendorgroups`;
  }

  /**
   * Lädt alle VendorGroups vom Backend.
   */
  fetchVendorGroups(): Observable<VendorGroup[]> {
    return this.http.get<VendorGroup[]>(this.baseUrl);
  }

}